import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface ErrorProps {
  type: 'network' | 'no-data';
  message: string;
  onRetry: () => void;
}

const ErrorHandler: React.FC<ErrorProps> = ({ type, message, onRetry }) => {
  let errorMessage;

  // Check the error type and display a corresponding message
  if (type === 'network') {
    errorMessage = (
      <>
        <Typography variant="h6" color="error" sx={{ mb: 2 }}>
          Network Error
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {'Unable to connect. Please check your internet connection.'}
        </Typography>
      </>
    );
  } else if (type === 'no-data') {
    errorMessage = (
      <>
        <Typography variant="h6" color="textSecondary" sx={{ mb: 2 }}>
          No Data Found
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {message || 'We couldn’t find any data for your request.'}
        </Typography>
      </>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // minHeight: '100vh',
        flexDirection: 'column',
      }}
    >
      {errorMessage}
      <Button variant="contained" color="error" onClick={onRetry}>
        Retry
      </Button>
    </Box>
  );
};

export default ErrorHandler;
